import notifyHoneybadger from 'chairisher/thirdparty/honeybadger';

/**
 * Sends an error to Honeybadger if a value's type does not match the expected type.
 *
 * @param {Object} params
 * @param {String} params.expectedType The expected `typeof` value (e.g. 'number', 'string').
 * @param {String} params.value The actual value being type-checked and compared to the expected type.
 * @param {Array=} params.tags Optional tags to pass along to Honeybadger for error grouping.
 */
export function assertType({ expectedType, value, tags = [] }) {
    const receivedType = typeof value;
    if (receivedType !== expectedType) {
        const err = new TypeError(`Expected ${expectedType}, but received ${receivedType}`);
        notifyHoneybadger({ err, context: { value }, tags });
    }
}

/**
 * Generic error handler for async operations.
 *
 * @param {Error} err The error object or value thrown by a failed async operation.
 */
export function handleAsyncError(err) {
    notifyHoneybadger({ err, context: { ...err } });
}
